import React from 'react';
import { RadioStyled } from './Styled';

interface RadioProps {
  label: string;
  value: string;
  name: string;
  id: string;
  checked?: boolean;
  onChange: (e: any) => void;
}

const Radio = (props: RadioProps) => {
  const { label, name, id, value, onChange, checked } = props;

  return (
    <RadioStyled>
      <label>
        <input type="radio" id={id} name={name} value={value} checked={checked} onChange={onChange} />
        <span>{label}</span>
      </label>
    </RadioStyled>
  );
};

Radio.defaultProps = {
  label: '',
  value: '',
  name: '',
  checked: false,
};

export default Radio;
export { Radio };
